export const FemaleAvatar = ({ className }: { className?: string }) => {
  return (
    <svg
      width="150"
      height="150"
      viewBox="0 0 150 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_5_9019)">
        <path
          d="M75.3614 150.723C116.982 150.723 150.723 116.982 150.723 75.3614C150.723 33.7405 116.982 0 75.3614 0C33.7405 0 0 33.7405 0 75.3614C0 116.982 33.7405 150.723 75.3614 150.723Z"
          fill="#7CE6E6"
        />
        <path
          d="M115.404 138.244C124.779 128.869 124.779 113.67 115.404 104.295C106.03 94.9197 90.8298 94.9197 81.4548 104.295C72.0799 113.67 72.0799 128.869 81.4548 138.244C90.8298 147.619 106.03 147.619 115.404 138.244Z"
          fill="#262424"
        />
        <path
          d="M75.3617 125.426C51.2765 125.426 31.6825 105.832 31.6825 81.7466V61.5771C31.6825 37.4919 51.2765 17.8979 75.3617 17.8979C99.4469 17.8979 119.056 37.4919 119.056 61.5771V81.7466C119.056 105.832 99.4469 125.426 75.3617 125.426Z"
          fill="#262424"
        />
        <path
          d="M75.3649 21.1925H75.3619C53.0598 21.1925 34.9803 39.272 34.9803 61.5741V81.7466C34.9803 104.049 53.0598 122.128 75.3619 122.128H75.3649C97.6671 122.128 115.746 104.049 115.746 81.7466V61.5741C115.746 39.272 97.6671 21.1925 75.3649 21.1925Z"
          fill="#F9C4A1"
        />
        <path
          d="M119.056 70.5322V62.3932C119.056 37.2209 98.1406 16.616 73.0019 17.9649C50.0098 19.1829 31.6825 38.2866 31.6825 61.5802V71.0925C31.6825 71.1656 65.6119 92.3703 84.3594 52.2536C92.0325 64.9509 103.734 70.7058 118.864 70.5566C118.931 70.6418 119.056 70.6418 119.056 70.5322Z"
          fill="#262424"
        />
        <path
          d="M34.9802 68.5835C34.3712 63.5563 35.2269 58.3039 37.203 53.4777C39.2553 48.61 42.341 44.2464 46.2464 40.6891C54.0414 33.4909 64.7259 29.5904 75.3618 29.5813C85.9977 29.5721 96.6761 33.4818 104.483 40.683C108.389 44.2403 111.474 48.6039 113.527 53.4716C115.5 58.3008 116.361 63.5563 115.743 68.5835C115.189 63.669 113.612 58.9249 111.115 54.6561C108.685 50.5249 105.489 46.8946 101.7 43.9593C94.2067 38.0979 84.7827 35.0834 75.3679 35.0499C65.95 35.0743 56.526 38.0948 49.0325 43.9532C45.2341 46.8869 42.0304 50.5184 39.5933 54.653C37.1028 58.9249 35.5317 63.6696 34.9802 68.5835Z"
          fill="#FF7E25"
        />
        <path
          d="M42.2503 89.3254C42.8791 83.6205 38.7641 78.486 33.0591 77.8572C27.3542 77.2283 22.2197 81.3433 21.5909 87.0483C20.962 92.7532 25.077 97.8877 30.782 98.5166C36.4869 99.1454 41.6214 95.0304 42.2503 89.3254Z"
          fill="#F9C4A1"
        />
        <path
          d="M128.913 90.5849C130.241 85.0012 126.791 79.3981 121.208 78.0699C115.624 76.7417 110.021 80.1915 108.693 85.7752C107.364 91.3589 110.814 96.9621 116.398 98.2903C121.982 99.6184 127.585 96.1686 128.913 90.5849Z"
          fill="#F9C4A1"
        />
        <path
          d="M61.0264 96.0241C61.0264 99.8261 62.5367 103.472 65.2251 106.161C67.9135 108.849 71.5598 110.36 75.3618 110.36C79.1638 110.36 82.8101 108.849 85.4985 106.161C88.1869 103.472 89.6972 99.8261 89.6972 96.0241H61.0264Z"
          fill="#FFFEF9"
        />
        <path
          d="M92.2975 180.977C91.2041 180.977 90.1554 180.543 89.3822 179.77C88.6091 178.996 88.1747 177.948 88.1747 176.854V133.894C88.2039 132.82 88.6509 131.8 89.4206 131.051C90.1903 130.302 91.2219 129.883 92.296 129.883C93.37 129.883 94.4016 130.302 95.1714 131.051C95.9411 131.8 96.3881 132.82 96.4172 133.894V176.854C96.4172 177.947 95.9833 178.995 95.2108 179.768C94.4383 180.542 93.3904 180.976 92.2975 180.977Z"
          fill="#F9C4A1"
        />
        <path
          d="M57.7592 180.977C56.6663 180.976 55.6184 180.542 54.8459 179.768C54.0734 178.995 53.6394 177.947 53.6394 176.854V133.894C53.6686 132.82 54.1156 131.8 54.8853 131.051C55.655 130.302 56.6867 129.883 57.7607 129.883C58.8347 129.883 59.8664 130.302 60.6361 131.051C61.4058 131.8 61.8528 132.82 61.882 133.894V176.854C61.882 177.948 61.4476 178.996 60.6744 179.77C59.9012 180.543 58.8526 180.977 57.7592 180.977Z"
          fill="#F9C4A1"
        />
        <path
          d="M63.9434 129.013H86.7802C88.0247 129.013 89.2181 129.507 90.0981 130.387C90.9781 131.267 91.4724 132.46 91.4724 133.705V159.282H59.2482V133.705C59.2482 133.088 59.3696 132.478 59.6056 131.909C59.8416 131.339 60.1875 130.822 60.6236 130.386C61.0596 129.95 61.5772 129.605 62.1469 129.369C62.7165 129.133 63.327 129.012 63.9434 129.013Z"
          fill="#FF7E25"
        />
        <path
          d="M68.5105 118.377H82.2126V131.406C82.2126 133.224 81.4912 134.968 80.2067 136.255C78.9222 137.541 77.1797 138.266 75.3615 138.269C73.5434 138.266 71.8008 137.541 70.5164 136.255C69.2319 134.968 68.5105 133.224 68.5105 131.406V118.377Z"
          fill="#F9C4A1"
        />
        <path
          d="M54.3061 90.7382C53.538 90.7358 52.8021 90.4296 52.259 89.8865C51.7159 89.3434 51.4098 88.6075 51.4073 87.8395V84.1612C51.4106 83.3937 51.7171 82.6586 52.2601 82.1161C52.8031 81.5737 53.5386 81.2679 54.3061 81.2655C55.0733 81.2679 55.8085 81.5738 56.351 82.1163C56.8935 82.6588 57.1994 83.394 57.2018 84.1612V87.8395C57.2002 88.6072 56.8947 89.3432 56.3521 89.8863C55.8095 90.4295 55.0739 90.7358 54.3061 90.7382Z"
          fill="#262424"
        />
        <path
          d="M96.4234 90.7382C95.6556 90.7358 94.92 90.4295 94.3774 89.8863C93.8348 89.3432 93.5293 88.6072 93.5277 87.8395V84.1612C93.5301 83.394 93.836 82.6588 94.3785 82.1163C94.921 81.5738 95.6562 81.2679 96.4234 81.2655C97.1909 81.2679 97.9264 81.5737 98.4694 82.1161C99.0124 82.6586 99.319 83.3937 99.3222 84.1612V87.8395C99.3198 88.6075 99.0136 89.3434 98.4705 89.8865C97.9274 90.4296 97.1915 90.7358 96.4234 90.7382Z"
          fill="#262424"
        />
      </g>
      <defs>
        <clipPath id="clip0_5_9019">
          <rect width="150" height="150" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const MaleAvatar = ({ className }: { className?: string }) => {
  return (
    <svg
      width="150"
      height="150"
      viewBox="0 0 150 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_5_9015)">
        <path
          d="M75.3614 150.723C116.982 150.723 150.723 116.982 150.723 75.3614C150.723 33.7405 116.982 0 75.3614 0C33.7405 0 0 33.7405 0 75.3614C0 116.982 33.7405 150.723 75.3614 150.723Z"
          fill="#00BBC4"
        />
        <path
          d="M48.6244 168.079H40.3818V161.258C40.3818 142.989 51.6845 129.713 67.2562 129.713V137.956C56.2945 137.956 48.6244 147.538 48.6244 161.258V168.079Z"
          fill="#FFFEF9"
        />
        <path
          d="M109.367 168.079H101.124V161.258C101.124 147.538 93.4635 137.956 82.4927 137.956V129.713C98.0643 129.713 109.367 142.98 109.367 161.258V168.079Z"
          fill="#FFFEF9"
        />
        <path
          d="M90.7386 136.311V165.384H59.175V136.311C59.175 132.657 64.4793 129.707 68.1271 129.707H81.7957C85.4435 129.713 90.7386 132.664 90.7386 136.311Z"
          fill="#FFFEF9"
        />
        <path
          d="M74.9597 139.737C74.9597 139.737 66.3792 135.897 66.3792 131.159V114.528H83.5372V131.159C83.5402 135.897 74.9597 139.737 74.9597 139.737Z"
          fill="#F9C4A1"
        />
        <path
          d="M74.9597 105.497C62.6521 105.497 51.4256 102.303 43.3505 96.5022C34.3771 90.0562 29.6332 80.9153 29.6332 70.0694V51.9735C29.6332 29.7457 49.5438 12.3532 74.9597 12.3532C100.375 12.3532 120.274 29.7579 120.274 51.9735V70.0694C120.274 80.9153 115.533 90.0562 106.572 96.5022C98.4937 102.309 87.2672 105.497 74.9597 105.497Z"
          fill="#FF9F00"
        />
        <path
          d="M43.0593 82.1138C43.8129 77.4301 40.6269 73.0223 35.9432 72.2687C31.2594 71.5152 26.8517 74.7012 26.0981 79.3849C25.3445 84.0686 28.5305 88.4764 33.2143 89.23C37.898 89.9836 42.3058 86.7975 43.0593 82.1138Z"
          fill="#F9C4A1"
        />
        <path
          d="M123.645 84.0309C125.46 79.6481 123.379 74.6234 118.996 72.8079C114.613 70.9925 109.589 73.0738 107.773 77.4566C105.958 81.8395 108.039 86.8642 112.422 88.6796C116.805 90.495 121.829 88.4137 123.645 84.0309Z"
          fill="#F9C4A1"
        />
        <path
          d="M74.9597 122.908C52.7501 122.908 34.5781 110.576 34.5781 88.3662V68.2059C34.5781 45.9964 52.7501 28.9936 74.9597 28.9936C97.1692 28.9814 115.344 45.9781 115.344 68.2059V88.3784C115.344 110.576 97.1692 122.908 74.9597 122.908Z"
          fill="#F9C4A1"
        />
        <path
          d="M74.9596 103.125C67.6062 103.125 60.5298 100.725 55.0307 96.3652C53.7463 95.3448 52.9198 93.856 52.7331 92.2263C52.5464 90.5966 53.0147 88.9594 54.035 87.675C55.0554 86.3906 56.5442 85.5641 58.1739 85.3774C59.8036 85.1907 61.4408 85.659 62.7252 86.6793C66.0472 89.3132 70.3984 90.7626 74.9749 90.7626C79.4813 90.7626 83.7838 89.3497 87.0875 86.7859C88.3828 85.7809 90.0243 85.3316 91.6509 85.5369C93.2775 85.7422 94.7559 86.5852 95.7609 87.8805C96.7659 89.1759 97.2152 90.8174 97.0099 92.444C96.8046 94.0705 95.9616 95.549 94.6663 96.554C89.1885 100.786 82.2126 103.125 74.9596 103.125Z"
          fill="#FFFEF9"
        />
        <path
          d="M57.7621 71.3178C57.7621 69.6328 56.3962 68.2668 54.7111 68.2668C53.0261 68.2668 51.6602 69.6328 51.6602 71.3178V73.7842C51.6602 75.4692 53.0261 76.8352 54.7111 76.8352C56.3962 76.8352 57.7621 75.4692 57.7621 73.7842V71.3178Z"
          fill="#AC5B0F"
        />
        <path
          d="M95.2207 76.8352C94.4144 76.8312 93.6422 76.5091 93.072 75.9389C92.5019 75.3688 92.1798 74.5966 92.1758 73.7903V71.3239C92.1798 70.5176 92.5019 69.7454 93.072 69.1752C93.6422 68.6051 94.4144 68.283 95.2207 68.279C96.027 68.283 96.7992 68.6051 97.3693 69.1752C97.9395 69.7454 98.2616 70.5176 98.2656 71.3239V73.7903C98.2616 74.5966 97.9395 75.3688 97.3693 75.9389C96.7992 76.5091 96.027 76.8312 95.2207 76.8352Z"
          fill="#AC5B0F"
        />
        <path
          d="M121.312 64.8352C120.425 64.9464 119.531 65.0024 118.636 65.0027H73.349C70.5008 65.0027 67.6805 64.4417 65.0491 63.3517C62.4176 62.2617 60.0267 60.6642 58.0127 58.6502C55.9987 56.6362 54.4011 54.2452 53.3111 51.6138C52.2212 48.9824 51.6602 46.162 51.6602 43.3138C51.6602 40.4656 52.2212 37.6453 53.3111 35.0138C54.4011 32.3824 55.9987 29.9915 58.0127 27.9775C60.0267 25.9635 62.4176 24.3659 65.0491 23.2759C67.6805 22.1859 70.5008 21.6249 73.349 21.6249H102.212C113.527 31.4052 120.956 46.8611 121.312 64.8352Z"
          fill="#FF9F00"
        />
        <path
          d="M86.7008 39.0053H112.561C114.864 38.9988 117.071 38.0812 118.699 36.4529C120.327 34.8245 121.245 32.6179 121.251 30.3151C121.247 28.0112 120.33 25.803 118.701 24.1734C117.073 22.5437 114.865 21.6253 112.561 21.6188H86.7008C84.399 21.6261 82.1936 22.5436 80.5661 24.1712C78.9385 25.7988 78.0209 28.0042 78.0137 30.306C78.0177 32.6098 78.9338 34.8183 80.5618 36.4486C82.1897 38.0788 84.3969 38.998 86.7008 39.0053Z"
          fill="#FF9F00"
        />
        <path
          d="M121.328 39.0052H82.6939C75.5166 39.0052 69.6982 44.8236 69.6982 52.0009V52.004C69.6982 59.1813 75.5166 64.9996 82.6939 64.9996H121.328C128.505 64.9996 134.323 59.1813 134.323 52.004V52.0009C134.323 44.8236 128.505 39.0052 121.328 39.0052Z"
          fill="#FF9F00"
        />
      </g>
      <defs>
        <clipPath id="clip0_5_9015">
          <rect width="150" height="150" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
